import React from "react"
// import { css } from "@emotion/core"
import { graphql } from "gatsby"
// import { rhythm } from "../../utils/typography"
import Layout from "./layout"


import Collapse from '@material-ui/core/Collapse'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'



const IndexPage = ({ data }) => {

  const [week1, showSchedule1] = React.useState(true)
  const [week2, showSchedule2] = React.useState(true)
  const [week3, showSchedule3] = React.useState(true)
  const [week4, showSchedule4] = React.useState(true)
  const [week5, showSchedule5] = React.useState(true)
  const [week6, showSchedule6] = React.useState(true)
  const [week7, showSchedule7] = React.useState(true)
  const [week8, showSchedule8] = React.useState(true)
  const [week9, showSchedule9] = React.useState(true)
  const [week10, showSchedule10] = React.useState(true)
  const [week11, showSchedule11] = React.useState(true)
  const [week12, showSchedule12] = React.useState(true)
  const [week13, showSchedule13] = React.useState(true)
  const [week14, showSchedule14] = React.useState(true)





  function handleClick1(id) {
    switch (id) {
      case "week1":
        showSchedule1(!week1)
        break;
    }
  }
  function handleClick2(id) {
    switch (id) {
      case "week2":
        showSchedule2(!week2)
        break;
    }
  }

  function handleClick3(id) {
    switch (id) {
      case "week3":
        showSchedule3(!week3)
        break;
    }
  }

  function handleClick4(id) {
    switch (id) {
      case "week4":
        showSchedule4(!week4)
        break;
    }
  }

  function handleClick5(id) {
    switch (id) {
      case "week5":
        showSchedule5(!week5)
        break;
    }
  }
  function handleClick6(id) {
    switch (id) {
      case "week6":
        showSchedule6(!week6)
        break;
    }
  }
  function handleClick7(id) {
    switch (id) {
      case "week7":
        showSchedule7(!week7)
        break;
    }
  }
  function handleClick8(id) {
    switch (id) {
      case "week8":
        showSchedule8(!week8)
        break;
    }
  }

  function handleClick9(id) {
    switch (id) {
      case "week9":
        showSchedule9(!week9)
        break;
    }
  }

  function handleClick10(id) {
    switch (id) {
      case "week10":
        showSchedule10(!week10)
        break;
    }
  }

  function handleClick11(id) {
    switch (id) {
      case "week11":
        showSchedule11(!week11)
        break;
    }
  }

  function handleClick12(id) {
    switch (id) {
      case "week12":
        showSchedule12(!week12)
        break;
    }
  }
  function handleClick13(id) {
    switch (id) {
      case "week13":
        showSchedule13(!week13)
        break;
    }
  }
  function handleClick14(id) {
    switch (id) {
      case "week14":
        showSchedule14(!week14)
        break;
    }
  }


  return (

    /*
    npm run build:skip-b
    npx netlify-cli@latest deploy --prod --dir=public --no-build
*/
    <Layout>
      <h1>
        <p>Web as Medium 1</p>
        <p>
          Rhodes Island School of Design, Graphic Design <br />
          GRAPH-3237-01, Fall 2026, 3 credits <br />
          Tuesdays, 1:10 – 6:10pm <br />
          DC 404, 30 N Main St, Providence, RI 02903 <br />
          Instructor: Minkyoung Kim, mkim37@risd.edu <br />
          TA: Nicole Sun, nsun01@risd.edu <br />
          Office hours:  <br /> 
         <span class="indent"> Minkyoung: By <a href="https://mkim.netlify.app/officehours" target="_blank">appointment</a>; </span><br />
          <span class="indent"> W 9:00 – 10:30am, F 8:00 – 9:30am</span><br />
          <span class="indent">Nicole: By <a href="https://calendar.app.google/vLJbni73r6etSPMp7" target="_blank">appointment</a>; M 10:00 – 11:00pm</span>
        </p>
      </h1>
      <div className="accordion-list">
        <ListItem id='week1' className="accordion" button onClick={() => handleClick1("week1")}>
          <ListItemText primary='Week 01: 09/15/26' className="accordion-heading  maxw-30" /> Hello World
        </ListItem>
        <Collapse in={!week1} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <ul>
                <li>Class introduction</li>
                <li>Student introduction</li>
                <li>Discuss presentation and class expectations</li>
                <li>Set-up accounts and software</li>
                <ul>
                  <li>Web browser: <a href="https://www.google.com/chrome/" target="_blank" rel="noopener noreferrer">Chrome</a>, <a href="https://www.mozilla.org/en-US/" target="_blank" rel="noopener noreferrer" rel="noopener noreferrer">Firefox</a>, or Safari</li>
                  <li>Text editor: <a href="https://www.sublimetext.com/" target="_blank" rel="noopener noreferrer">Sublime</a></li>
                  <li>Web prototype tool: <a href="http://figma.com" target="_blank" rel="noopener noreferrer">Figma</a> or Adobe XD</li>
                  <li>Hosting space: <a href="http://github.com" target="_blank" rel="noopener noreferrer" >Github</a> (<a href="https://docs.google.com/document/d/1vk6vJiTXhBOPzLV6Qt5Xkc3Q-IgyIl4uN5zsw0bEttY/edit?usp=sharing" target="_blank" rel="noopener noreferrer">Getting Started</a>)</li>
                  <li><a href="https://wam1f26.slack.com/" target="_blank" rel="noopener noreferrer">Slack</a></li>
                </ul>
                <li>Talk</li>
                <ul>
                  <li><a href="https://docs.google.com/presentation/d/19HQrur4GYoJE0dVeKCtfW8HYzlx96RFNQmRJqXsQdy4/edit?usp=sharing" target="_blank" rel="noopener noreferrer">HTML Basics</a></li>
                  <li><a href="https://docs.google.com/presentation/d/1wYrHzXloZtNI3DNKy0C5Ely5nyZlLjaLQBgNXTtsqK4/edit?usp=sharing" target="_blank" rel="noopener noreferrer">How the Internet Works and How to Stay Organized</a></li>
                </ul>
                <li>Assignments due next week</li>
                <ul>
                  <li>Finish Exercise 1 and 2 </li>
                  <li>Reading response</li>
                    <ul>
                      <li><a href="http://writing.upenn.edu/epc/authors/goldsmith/if_it_doesnt_exist.html" target="_blank" rel="noopener noreferrer">If it Doesn’t Exist on the Internet, It Doesn’t Exist</a></li>
                      <li><a href="https://theoutline.com/post/4560/asian-american-writers-wikipedia-edit-a-thon-kundiman-aaww?zd=2&zi=ardr4wjs" target="_blank" rel="noopener noreferrer">If an Asian American Author Doesn’t Have a Wikipedia Page, Do They Exist?</a></li>
                      <li><a href="https://restofworld.org/2024/singapore-writers-reject-ai-training/" target="_blank">Writers and Publishers in Singapore Reject a Government Plan to Train AI on Their Work</a></li>
                    </ul>
                </ul>
              </ul>
            </div>
          </List>
        </Collapse>
        <ListItem id='week2' className="accordion" button onClick={() => handleClick2("week2")}> 
          <ListItemText primary='Week 02: 09/22/26' className="accordion-heading  maxw-30" /> The Internets
        </ListItem>
        <Collapse in={!week2} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <ul>
                <li>Reading discussion</li> 
                <ul>
                    <li><a href="http://writing.upenn.edu/epc/authors/goldsmith/if_it_doesnt_exist.html" target="_blank" rel="noopener noreferrer">If it Doesn’t Exist on the Internet, It Doesn’t Exist</a></li>
                    <li><a href="https://theoutline.com/post/4560/asian-american-writers-wikipedia-edit-a-thon-kundiman-aaww?zd=2&zi=ardr4wjs" target="_blank" rel="noopener noreferrer">If an Asian American Author Doesn’t Have a Wikipedia Page, Do They Exist?</a></li>
                    <li><a href="https://restofworld.org/2024/singapore-writers-reject-ai-training/" target="_blank">Writers and Publishers in Singapore Reject a Government Plan to Train AI on Their Work</a></li>
                </ul>
                <li>Talk/Demo</li>
                <ul>
                  <li><a href="https://docs.google.com/presentation/d/1TyjYeS52cCMAETVRF-2cLLx9kQqExAU1G9y9-23a4Qw/edit?usp=sharing" target="_blank" rel="noopener noreferrer">CSS Form and Content</a></li>
                  <li><a href="https://docs.google.com/presentation/d/1Pl1JX77fW7wF4B3SSmCgjSqU-gEiKkmykdi7s2GX5zc/edit?usp=sharing" target="_blank" rel="noopener noreferrer">CSS Layout</a></li>
                </ul>
                <li>Exercise 2: group review</li>
                <li>Introduction of Exercise 3</li>
                <li>Assignments due next week</li>
                <ul>
                  <li>Finish Exercise 3 </li>
                  <li>Recommended reading: <a href="http://www.coldbacon.com/writing/borges-garden.html#_jmp0_" target="_blank" rel="noopener noreferrer">The Garden of Forking Paths</a>, <a href="https://content.sakai.rutgers.edu/access/content/user/jpsmall/JPSmall-Offprints/JPSmall-Is%20Linear%20Perspective%20Necessary.pdf" target="_blank" rel="noopener noreferrer">Is Linear Perspective Necessary?</a></li>
                </ul>
              </ul>
            </div>
          </List>
        </Collapse>
        <ListItem id='week3' className="accordion" button onClick={() => handleClick3("week3")}> 
          <ListItemText primary='Week 03: 09/29/26' className="accordion-heading  maxw-30" /> Hyperlinks
        </ListItem>
        <Collapse in={!week3} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <ul>
                <li>Student presentation: Juan</li>
                <li>Talk/Demo: <a href="https://docs.google.com/presentation/d/1tBhDisXy24SLF6HhI1gaZNa8bwu9P2vnLFX2tHQoltQ/edit?usp=sharing" target="_blank" rel="noopener noreferrer">CSS transforms</a>, <a href="https://docs.google.com/presentation/d/1gKpw8_bT50IRTtBB0H3anansE1HXMENcT8INbN2Hljg/edit?usp=sharing" target="_blank" rel="noopener noreferrer">CSS motion</a></li>
                <li>Introduction of Exercise 4 and 5: CSS Letterforms</li>
                <li>Exercise 3: small group review</li>

                <li>Assignments due next week</li>
                <ul>
                  <li>Finish Exercise 4 and 5</li>
                {/*   <li>Suggested Codeacademy tracks</li>
                  <ul>
                    <li>CSS: Colors</li>
                    <li>CSS: Typography</li>
                    <li>CSS: Grid</li>
                  </ul> */}
                  <li>Suggested reading: <a href="https://unbag.net/end/black-gooey-universe" target="_blank" rel="noopener noreferrer">Black Gooey Universe</a> and <a href="http://contemporary-home-computing.org/vernacular-web-2/" target="_blank" rel="noopener noreferrer">Vernacular Web 2</a></li>

                </ul>
              </ul>
            </div>
          </List>
        </Collapse>
        <ListItem id='week4' className="accordion" button  disabled>
           {/* onClick={() => handleClick4("week4")}>  */}
          <ListItemText primary='Week 04: 10/06/26' className="accordion-heading  maxw-30" /> Interface Aesthetics
        </ListItem>
        <Collapse in={!week4} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <ul>
                <li>Student presentation: Kiry</li>
                <li>Talk/Demo: <a href="https://docs.google.com/presentation/d/1k-j5xf7yvzp3xHwZ6TJJ487HWqChf6aC1Z3UFkxrocA/edit?usp=drive_link" target="_blank" rel="noopener noreferrer">JavaScript: DOM Manipulation & Queries, Event Handling
</a></li>
                <li>Exercise 4: group review</li>
                <li>Introduction of Exercise 6: On/Off</li>
                <li>Introduction of Project 1: Hyperlinked Set</li>
                <li>Assignments due next week</li>
                <ul>
                  <li>Finish Exercise 5</li>
                  <li>Project 1: planning/sketch</li>
                   <li>Suggested Codeacademy tracks: <a href="https://www.codecademy.com/learn/introduction-to-javascript" target="_blank" rel="noopener noreferrer">Introduction of JavaScript</a></li>
                  <ul>
                    <li>Introduction</li>
                  </ul>
                  <li>Recommended reading: <a href="https://www.cca.qc.ca/en/articles/69294/is-a-database-a-museum" target="_blank" rel="noopener noreferrer">Is a Database a Museum?</a></li>
                </ul>
              </ul>
            </div>
          </List>
        </Collapse>
        <ListItem id='week5' className="accordion" button  disabled>
            {/* onClick={() => handleClick5("week5")}>  */}
          <ListItemText primary='Week 05: 10/13/26' className="accordion-heading  maxw-30" />  Collection
        </ListItem>
        <Collapse in={!week5} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <ul>
                <li>Student presentation: Emma</li>
                {/* <li>Reading discussion:  <a href="https://www.dropbox.com/scl/fi/wx7c9odlxgeopttk666zj/david_reinfurt_infinite_versioning.pdf?rlkey=eb18wp6paadcxknoy125qkji5&dl=0" target="_blank" rel="noopener noreferrer">Infinite Versioning</a></li> */}
                <li>Project 1 & Exercise 6: small group review</li>
                <li>Assignments due next week</li>
                <ul>
                  <li>Project 1: design</li>
                  <li>Suggested Codeacademy tracks: <a href="https://www.codecademy.com/learn/introduction-to-javascript" target="_blank" rel="noopener noreferrer">Introduction of JavaScript</a></li>
                  <ul>
                    <li>Conditionals</li>
                  </ul>
                  {/* <li>Reading response: <a href="https://www.dropbox.com/scl/fi/wx7c9odlxgeopttk666zj/david_reinfurt_infinite_versioning.pdf?rlkey=eb18wp6paadcxknoy125qkji5&dl=0" target="_blank" rel="noopener noreferrer">Infinite Versioning</a></li> */}
                  <li>Suggested reading: <a href="https://www.e-flux.com/journal/10/61362/in-defense-of-the-poor-image/" target="_blank" rel="noopener noreferrer">In Defense of the Poor Image</a></li>
                </ul>
              </ul>
            </div>
          </List>
        </Collapse>
        <ListItem id='week6' className="accordion" button disabled>
           {/* onClick={() => handleClick6("week6")}>  */}
          <ListItemText primary='Week 06: 10/20/26' className="accordion-heading  maxw-30" /> Repoduction
        </ListItem>
        <Collapse in={!week6} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <ul>
                <li>Student presentation: Bonnie and Alex</li>
                <li>Project 1: group review</li>
                <li>Talk/Demo: <a href="https://docs.google.com/presentation/d/1HYHGUYuAYmDV29EM-6hNVVGXGn58ksifrPk1F77AmTw/edit?usp=drive_link" target="_blank" rel="noopener noreferrer">Responsive Web</a></li>
                 <li>Exercise 7: Media Query Relay (1/5)</li>
                <li>Assignments due next class</li>
                <ul>
                  <li>Project 1: prototype</li>
                  <li>Suggested reading: <a href="https://ourdataourselves.tacticaltech.org/posts/30-on-weaponised-design/" target="_blank" rel="noopener noreferrer">On Weaponised Design</a> and  <a href="http://contentsmagazine.com/articles/made-to-measure/" target="_blank" rel="noopener noreferrer">Made to Measure</a></li>
                  <li>Suggested Codeacademy tracks: <a href="https://www.codecademy.com/learn/introduction-to-javascript" target="_blank" rel="noopener noreferrer">Introduction of JavaScript</a></li>
                  <ul>
                    <li>Functions</li>
                    <li>Scope</li>
                    <li>Arrays</li>
                  </ul>
                </ul>
              </ul>
            </div>
          </List>
        </Collapse>
        <ListItem id='week7' className="accordion" button  disabled>
           {/* onClick={() => handleClick7("week7")}> */}
          <ListItemText primary='&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 10/27/26' className="accordion-heading  maxw-30" /> Advising Day — No Class
        </ListItem>
        <Collapse in={!week7} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <ul>
                <li>Student presentation: Hyunmin</li>
                <li>Project 2: 1:1 review</li>
               
                <li>Assignments due next week</li>

                <ul>
                  <li>Finish Project 2</li>
                  <li>Suggested reading/watching:  <a href="https://www.dropbox.com/s/p5nf2esihc6r6ca/ghost_in_the_machine.pdf?dl=0" target="_blank" rel="noopener noreferrer">Challenging the Algorithms of Oppression</a>, and <a href="https://www.newyorker.com/tech/annals-of-technology/chatgpt-is-a-blurry-jpeg-of-the-web" target="_blank" rel="noopener noreferrer">ChatGPT is a Blurry JPEG of the Web</a></li>
                  <li>Suggested Codeacademy tracks: <a href="https://www.codecademy.com/learn/introduction-to-javascript" target="_blank" rel="noopener noreferrer">Introduction of JavaScript</a></li>
                  <ul>
                    <li>Loop</li>
                    <li>Iterators</li>
                    <li>Objects</li>
                  </ul>

                </ul>
              </ul>
            </div>
          </List>
        </Collapse>
        <ListItem id='week8' className="accordion" button  disabled>
          {/* onClick={() => handleClick8("week8")}>  */}
          <ListItemText primary='Week 07: 11/03/26' className="accordion-heading  maxw-30" /> Users
         
        </ListItem>
        <Collapse in={!week8} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <ul>
                <li>Student presentation: Anna, Candice, and Josh</li>
                <li>Review/Discuss <a href="https://docs.google.com/document/d/1lCUC8q00CbQp9AV8wQqkdZMeLIOlEesEFp4aOfiQe84/edit?usp=sharing" target="_bank" rel="noopener noreferrer">Using AI for Debugging: What to Consider</a></li>
                <li>Project 1: Small group review</li>
                <li>Exercise 7: Media Query Relay (2/5)</li>

                <li>Assignments due next week</li>
                <ul>
                  <li>Project 1: Finish project</li>
                  {/* <li>Suggested reading: <a href="http://adht.parsons.edu/designstudies/plot/designing-in-liquid-times-generative-graphic-design-in-an-age-of-uncertainty/" target="_blank" rel="noopener noreferrer">Generative Graphic Design in an Age of Uncertainty</a></li> */}
                  <li>Suggested Codeacademy tracks: catch up on any incomplete ones </li>
                </ul>
              </ul>
            </div>
          </List>
        </Collapse>
        <ListItem id='week9' className="accordion" button  disabled>
            {/* onClick={() => handleClick9("week9")}>  */}
          <ListItemText primary='Week 08: 11/10/26' className="accordion-heading  maxw-30" />  Change over Time
        </ListItem>
        <Collapse in={!week9} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <ul>
                <li>Student presentation: Hamin</li>
                <li>Project 1: final review</li>
                <li>Assignments due next week</li>
                <ul>
                  <li>Project 2: planning and design sketch</li>
                  <li>Reading Question: <a href="https://www.dropbox.com/scl/fi/wx7c9odlxgeopttk666zj/david_reinfurt_infinite_versioning.pdf?rlkey=eb18wp6paadcxknoy125qkji5&dl=0" target="_blank">Infinite Versioning</a></li>
                  <li>Suggested Codeacademy tracks: catch up on any incomplete ones </li>
                </ul>
              </ul>
            </div>
          </List>
        </Collapse>
        <ListItem id='week10' className="accordion" button  disabled>
            {/* onClick={() => handleClick10("week10")}>  */}
          <ListItemText primary='Week 09: 11/17/26' className="accordion-heading  maxw-30" />          Generative Design


        </ListItem>
        <Collapse in={!week10} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <ul>
                <li>Student presentation:  Maria and Roye</li>
                <li>Project 2: small group review</li>
                <li>Exercise 7: Media Query Relay (3/5)</li>
                <li>Assignments due next week</li>
                <ul>
                  <li>Project 2: Design revision and prototype</li>
                  <li>Suggested Codeacademy tracks: catch up on any incomplete ones </li>
                </ul>
              </ul>
            </div>
          </List>
        </Collapse>
        <ListItem id='week11' className="accordion" button  disabled>
            {/* onClick={() => handleClick11("week11")}>  */}
          <ListItemText primary='Week 10: 11/24/26' className="accordion-heading  maxw-30" />  Working wiht Data 
        </ListItem>
        <Collapse in={!week11} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <ul>
                <li>Student presentation: Punch and James</li>
                 <li>Talk/Demo: <a href="https://docs.google.com/presentation/d/1AEO6imwmWiTLivIPLtR_psZDWRaOJ0idEG3n-4Alp2U/edit?usp=sharing" target="_blank" rel="noopener noreferrer">JavaScript Conditionals/Function/Loop + Math.random()</a></li>
                <li>Project 2: small group review</li>
                <li>Exercise 7: Media Query Relay (4/5)</li>
                <li>Assignments due next class</li>
                <ul>
                  <li>Project 2: Prototype</li>
                  <li>Suggested reading/watching:  <a href="https://www.youtube.com/watch?v=iRVZozEEWlE" target="_blank" rel="noopener noreferrer">Challenging the Algorithms of Oppression</a>, and <a href="https://www.newyorker.com/tech/annals-of-technology/chatgpt-is-a-blurry-jpeg-of-the-web" target="_blank" rel="noopener noreferrer">ChatGPT is a Blurry JPEG of the Web</a></li>
                  <li>Suggested Codeacademy tracks: catch up on any incomplete ones </li>
                </ul>
              </ul>
            </div>
          </List>
        </Collapse>
        <ListItem id='week12' className="accordion" button  disabled>
            {/* onClick={() => handleClick12("week12")}>   */}
          <ListItemText primary='Week 11: 12/01/26' className="accordion-heading  maxw-30" /> Platform
        </ListItem>
        <Collapse in={!week12} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <ul>
                <li>Student presentation: Max</li>
                <li>Project 2 and Exercise 8: 1:1 meetings</li>
                <li>After class</li>
                <ul>
                  <li>Project 2: Prototype</li>
                  <li>Suggested Reading: <a href="https://www.dropbox.com/scl/fi/irxyimaahugozlv5qoqp7/balkin.pdf?rlkey=vzub4le7cqxto4wfjcvz73qv1&st=o77i1y3g&dl=0" target="_blank" rel="noopener noreferrer">Sometimes it Looks like a Duck, Sometimes it Looks like a Rabbit</a></li>
                </ul>
              </ul>
            </div>
          </List>
        </Collapse>
        <ListItem id='week13' className="accordion" button  disabled>
          {/* onClick={() => handleClick13("week13")}>  */}
          <ListItemText primary='Week 12: 12/08/26' className="accordion-heading  maxw-30" /> Network
        </ListItem>
        <Collapse in={!week13} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <ul>
                <li>Student presentation: Cathy</li>
                <li>Talk/Demo: <a href="https://docs.google.com/presentation/d/1bzApas4b9LyHy9dZpWv02s1JNAhmpaVnkG33ZFmP4qs/edit?usp=sharing" target="_blank" rel="noopener noreferrer">p5.js Intro</a></li>
                <li>Orientation for the final documentation: Upload final documentation package on <a href="https://www.dropbox.com/request/s37uhGuN2KdKl6Ktyv37" target="_blank" rel="noopener noreferrer">Dropbox folder</a> and update your Github repository. More details on <i><a href="https://docs.google.com/document/d/1lzThEka7w6q2Fkm6QKMs02p0hjxIS3mmaI1Kx4OlYQ0/edit?usp=sharing" target="_blank" rel="noopener noreferrer">Final checklist</a></i>.
                  (Due 12/16/25)</li>
                <li>Project 2: 1:1 meeting</li>

                <li>After class</li>
                <ul>
                  <li>Recommended: Watch <a href="https://github.com/RISD-Code-Lab/spring2021/tree/main/session-05" target="_blank">Code Lab Session 5: Launch Website</a></li>
                  <li>Due 12/16/25: Upload final documentation package on <a href="https://www.dropbox.com/request/s37uhGuN2KdKl6Ktyv37" target="_blank" rel="noopener noreferrer">Dropbox folder</a> and your Github repository. More details on <i><a href="https://docs.google.com/document/d/1lzThEka7w6q2Fkm6QKMs02p0hjxIS3mmaI1Kx4OlYQ0/edit?usp=sharing" target="_blank" rel="noopener noreferrer">Final checklist</a></i>.</li>
                </ul>
              </ul>
            </div>
          </List>
        </Collapse>
           <ListItem id='week14' className="accordion" button  disabled>
             {/* onClick={() => handleClick14("week14")}> */}
          <ListItemText primary='Week 13: 12/15/26' className="accordion-heading  maxw-30" />   Final
        </ListItem>
        <Collapse in={!week14} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
                <li>Review Media Query Relay together 🎉</li>
               <li>Project 2: Last group review with <a href="https://kaaathy.com/" target="_blank">kathy wu</a></li>
                <li>After class</li>
                <ul>
                  <li>Due 12/16/25: Upload final documentation package on <a href="https://www.dropbox.com/request/s37uhGuN2KdKl6Ktyv37" target="_blank" rel="noopener noreferrer">Dropbox folder</a> and your Github repository. More details on <i><a href="https://docs.google.com/document/d/1lzThEka7w6q2Fkm6QKMs02p0hjxIS3mmaI1Kx4OlYQ0/edit?usp=sharing" target="_blank" rel="noopener noreferrer">Final checklist</a></i>.</li>
                </ul>
            </div>
          </List>
        </Collapse>

          <ListItem id='week14' className="accordion" button disabled>
          <ListItemText primary='&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  12/20/26' className="accordion-heading  maxw-30" />  Class Documentation Due
        </ListItem>
        <Collapse in={!week14} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
             
            </div>
          </List>
        </Collapse>
        
       
      </div>
      <h4></h4>
    </Layout>
  )
}

export default IndexPage




// export const query = graphql`
//   query {
//     allMarkdownRemark(
//         sort: { fields: [frontmatter___date], order: ASC } 
//         filter: {fileAbsolutePath: {regex: "/t3f19/_project/.*.md$/"}}
//         ) {
//       totalCount
//       edges {
//         node {
//           html
//           id
//           frontmatter {
//             title
//             date
//           }
//           fields {
//             slug
//           }
//         }
//       }
//     }
//   }
// `